<mat-icon
  (menuClosed)="onMenuClosed()"
  [class.menu-open]="trigger.menuOpen"
  [matMenuTriggerFor]="beforeMenu"
  *ngIf="showMenu$ | async"
  #trigger="matMenuTrigger"
  class="extra-large-icon menu-button"
>more_horiz</mat-icon>

<mat-menu
  #beforeMenu="matMenu"
  class="global-menu"
  xPosition="before"
>
  <button
    *ngFor="let state of (rejectedStates$ | async)"
    mat-menu-item
    (click)="rejectStatus(state.label, state.id)"
  >{{state.label}}</button>
</mat-menu>
